import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Store } from '@ngxs/store';
import { UserRole } from '../enum/user-role.enum';
import { AuthState } from '../../store/auth/auth.state';

export function RoleGuard(roles: UserRole[]): CanActivateFn {
    return () => {
        const userRoles = inject(Store).selectSnapshot(AuthState.getRoles);
        return roles.some((role: UserRole) => userRoles.includes(role));
    };
}
